import React, { useEffect } from "react";
import "../../styles/filters-form.less";
import { useDispatch } from "react-redux";
import ServiceProfileCreateForm from "../../components/ServiceProfileCreateForm/ServiceProfileCreateForm";
import {
  fetchInvoicePeriodStatus,
  fetchPaymentTypeStatus,
  fetchPrePaymentPeriodStatus,
} from "../../store/slices/rtkDictionaries";

const ServiceProfileCreateFormContainer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchInvoicePeriodStatus());
    dispatch(fetchPrePaymentPeriodStatus());
    dispatch(fetchPaymentTypeStatus());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container_height">
      <ServiceProfileCreateForm />
    </div>
  );
};

export default ServiceProfileCreateFormContainer;
